module.exports = __webpack_public_path__ + "static/img/camerafor2.65ece6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/camerafor2.png
// module id = mhoo
// module chunks = 24